{
  "my_calendar": {
    "upcoming": "Upcoming",
    "recent": "Recent",
    "calendar": "Calendar",
    "list": "List"
  }
}
